// extracted by mini-css-extract-plugin
export var dropdownButton = "_2g-0";
export var fullWidthDropdownButton = "_2g-1";
export var icon = "_2g-3";
export var iconPlaceholder = "_2g-2";
export var menuItemRow = "_2g-8";
export var separator = "_2g-c";
export var shortcutContainer = "_2g-7";
export var shortcutIconLg = "_2g-6";
export var shortcutIconMd = "_2g-5";
export var shortcutIconSm = "_2g-4";
export var submenuChevron = "_2g-b";
export var submenuDropdown = "_2g-9";
export var submenuTriggerRow = "_2g-a";